import { AreaTrendChart } from '@repo/ui-web';

const data = [
  { timestamp: '2026-02-11T09:00:00Z', activeUsers: 120, signups: 18 },
  { timestamp: '2026-02-11T10:00:00Z', activeUsers: 156, signups: 24 },
  { timestamp: '2026-02-11T11:00:00Z', activeUsers: 141, signups: 20 },
  { timestamp: '2026-02-11T12:00:00Z', activeUsers: 188, signups: 31 },
  { timestamp: '2026-02-11T13:00:00Z', activeUsers: 205, signups: 36 },
];

const series = [
  { key: 'activeUsers', label: 'Active users' },
  { key: 'signups', label: 'Signups' },
];

export function AreaTrendChartShowcase() {
  return (
    <div className="max-w-2xl">
      <AreaTrendChart
        data={data}
        series={series}
        yAxisLabel="Users"
        valueFormatter={(value, key) =>
          key === 'signups' ? `${Math.round(value)} new` : `${Math.round(value)} users`
        }
      />
    </div>
  );
}

